import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionTemplateGetPathParameters } from 'api/actions/revision-template-get/revision-template-get-path-parameters';
import { RevisionTemplateGetResponse } from 'api/actions/revision-template-get/revision-template-get-response';

type RevisionTemplateGetQueryParameters = Record<string, any>;

/**
 * The path of the RevisionTemplateGet action.
 */
export const revisionTemplateGetActionPath = new SweetPath<keyof RevisionTemplateGetPathParameters>(
  '/api/revision-template/get/{revisionTemplateId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionTemplateGet actions.
 */
export default function createRevisionTemplateGetAction(axios: AxiosInstance) {
  return function revisionTemplateGetAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionTemplateGetPathParameters;
    query?: RevisionTemplateGetQueryParameters;
  }) {
    const path = revisionTemplateGetActionPath.insert(parameters);

    return axios.request<RevisionTemplateGetResponse, RevisionTemplateGetResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
